<script setup lang="ts">
import { AppRepository } from '@sortera/dvfv-persistence'
import { computed, onMounted } from 'vue'

import { FeatConfirm } from '@/components/feature/FeatConfirm/index.ts'
import { UiEnvBanner } from '@/components/ui/UiEnvBanner/index.ts'
// eslint-disable-next-line no-restricted-imports
import { compressImage, convertHeicToJpg, isHeic, uploadImages } from '@/integrations/image-utils/image-utils.ts'
import { useProvideImageUtils } from '@/integrations/image-utils/index.ts'
import { UiRouterView, useAuthorizeNavigation, useRoute } from '@/services/routing/index.ts'
import { getCurrentLocale, guessDefaultLocale, switchLanguage } from '@/services/translation/index.ts'
import { useInitAppTitles } from '@/services/use-app-titles.ts'
import { getBackendEnvName, getFirebaseEnvName } from '@/utils/env.ts'

const { VITE_ENVIRONMENT_NAME } = import.meta.env

const route = useRoute()

useAuthorizeNavigation()

const appRepository = new AppRepository()
const { hasUpdate } = appRepository.useHasUpdate('fv')

const env = computed(() => ({
  frontendEnv: VITE_ENVIRONMENT_NAME,
  backendEnv: getBackendEnvName(),
  firebaseEnv: getFirebaseEnvName(),
}))

useInitAppTitles(route, getCurrentLocale())

useProvideImageUtils({ uploadImages, compressImage, convertHeicToJpg, isHeic })

onMounted(() => {
  switchLanguage(guessDefaultLocale())
})

function refreshApp(): void {
  window.location.reload()
}
</script>
<template>
  <UiEnvBanner v-bind="env" />
  <div
    v-if="hasUpdate"
    class="bg-base-100 absolute z-30 flex w-full flex-col items-center p-2"
  >
    <button
      class="btn btn-primary btn-lg"
      @click="refreshApp"
    >
      {{ $t('general.new-version') }}
    </button>
  </div>
  <UiRouterView />
  <FeatConfirm />
</template>
